module.exports = __webpack_public_path__ + "img/invitation.33cff26e.png";